import React from 'react';

const formatDay = (isoDate) => {
  const d = new Date(`${isoDate}T00:00:00`);
  return d.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' });
};

const formatTime = (isoTime) => {
  return new Date(isoTime).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
};

// Visual per-day timeline of activity: a center line with days alternating left/right of it.
// Days with no activity are skipped entirely rather than rendered as empty rows.
const PeriodTimeline = ({ timeline }) => {
  const activeDays = (timeline || []).filter(day => day.items.length > 0);

  if (activeDays.length === 0) {
    return null;
  }

  return (
    <section className="period-summary-section period-summary-timeline">
      <h2>Timeline</h2>
      <div className="period-summary-timeline-track">
        {activeDays.map((day, index) => (
          <div
            className={`period-summary-timeline-row ${index % 2 === 0 ? 'is-left' : 'is-right'}`}
            key={day.date}
          >
            <div className="period-summary-timeline-node" />
            <div className="period-summary-timeline-card">
              <div className="period-summary-timeline-day-header">{formatDay(day.date)}</div>
              <div className="period-summary-timeline-items">
                {day.items.map((item, idx) => (
                  <div className="period-summary-timeline-item" key={`${day.date}-${idx}`}>
                    {item.image ? (
                      <img src={item.image} alt="" className="period-summary-timeline-item-image" />
                    ) : item.icon ? (
                      <img src={item.icon} alt="" className="period-summary-timeline-item-icon icon" />
                    ) : null}
                    <div className="period-summary-timeline-item-body">
                      <span className="period-summary-timeline-item-title">{item.title}</span>
                      <span className="period-summary-timeline-item-time">{formatTime(item.time)}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PeriodTimeline;
